import React from 'react';

const IceWarming = () => {
    return (
        <div>
            <p>
                Home page - Video landing page
            </p>
            <p>
                Ice Sports - Glass design
            </p>
            <p>
                Shop - ES6 JavaScript Vanilla Shopping cart
            </p>
        </div>
    )
}
export default IceWarming;